import { HistoryService } from '@philips-internal/oswald-ui-core/lib/services/history-service';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';
import { isMobile } from '@philips-internal/oswald-ui-utils';

export class MyChartUtils {

  static pushToSubRoute(route: string): void {
    if (isMobile()) {
      applicationContext.redirect(route);
    } else {
      HistoryService.push(route);
    }
  }
}